import { AutocompleteArrayInput } from 'react-admin';
import { useState, useEffect } from 'react';
import { goApi } from '../../../services';

interface Product {
    id: string;
    name: string;
}

export const EcomProductAutoComplete = (props: any) => {
    const [searchText, setSearchText] = useState('');
    const [data, setData] = useState<Product[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const fetchProducts = async () => {
            setIsLoading(true);
            try {
                const params = searchText
                    ? `?name=${encodeURIComponent(searchText)}`
                    : `?name=NOT_AVAILABLE`;

                const response = await goApi.get(`/ecom/products${params}`);
                const products = response.data?.items || [];

                setData(products);
            } catch (error) {
                console.error('Failed to fetch products', error);
                setData([]);
            } finally {
                setIsLoading(false);
            }
        };

        fetchProducts();
    }, [searchText]);

    return (
        <AutocompleteArrayInput
            {...props}
            source={props.source || 'children'}
            label={props.label || 'For Combo Products'}
            fullWidth
            choices={data}
            optionText="name"
            optionValue="id"
            loading={isLoading}
            setFilter={(value: string) => setSearchText(value)}
            debounce={500}
        />
    );
};
